module.exports = __webpack_public_path__ + "static/media/potato.fb1d0a05.jpg";